import { Page } from '@web/components/page';
import { withServerProps } from '@web/library/with-server-props';
import { useRoute } from 'shared/library/routes/route';
import { ShopCategoryScreen, ShopCategoryScreenProps } from 'shared/screens/shop/shop-category';

export default function ShopCategoryPage(props: ShopCategoryScreenProps) {
  const route = useRoute();
  const categoryItems = props.products.data.map((product, index) => ({
    position: props.products.from + index,
    name: product.name,
    url: route('shop.product', { product: product.slug }),
  }));

  return (
    <Page
      {...props}
      register={(seo) =>
        seo
          .setTitle(props.productCategory.name)
          .setDescription(props.productCategory.summary)
          .setImage(props.productCategory.avatar?.url)
          .forCategory(props.productCategory, {
            numberOfItems: props.products.total,
            items: categoryItems,
          })
      }
    >
      <ShopCategoryScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps(ShopCategoryScreen.pageBuilder);
